import { nextDate } from "./nextDate";
import { setNextRefresh } from "../../utilities/nextRefresh";
import { refreshCallback } from "./refreshCallback";
import { startTimer } from "./startTimer";
// TODO: fix 12am - 3am issue within nextDate()
export function refreshDefault(status, date) {
    if (!status) {
        return;
    }
    /* SET DEFAULT REFRESHES AT 3 AM */
    // TODO: Is there value in this anymore?
    const dailyIntervalValue = 12; // interval by hrs
    const dailyInt = (dailyIntervalValue * 1) / 24;
    const nextDailyIntDate = nextDate(dailyInt, date.getDay(), "3:00");
    setNextRefresh(nextDailyIntDate);
    startTimer(false, nextDailyIntDate, dailyInt, false, refreshCallback);
}
